import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getPostalCodeList(params) {
  return request({
    url: URL.mdm.basicData.postalCode,
    method: 'get',
    params
  })
}

export function savePostalCode(data) {
  return request({
    url: URL.mdm.basicData.postalCode,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function delPostalCode(uuid) {
  return request({
    url: URL.mdm.basicData.postalCode + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}

export function queryPostalCodeByCode(data) {
  return request({
    url: URL.mdm.queryPostalCodeByCode,
    method: 'post',
    data
  })
}
